export default __webpack_public_path__ + "static/media/Keith_Parker.136a5bf0.jpg";